module.exports = __webpack_public_path__ + "media/images/icons/check-circle-solid-72b1e7340a6e2b1d1eaf4e01170138d3.svg";